import { DedicatedPackageOutput } from '@allocab/allocab-dedicated-driver-types';

import { Link } from '../../components/atomic/Link';
import { BadgeIndicator } from '../../components/BadgeIndicator';
import { TableColumn } from '../../components/table/types';
import { TripPackageAssignButton } from '../../components/trip-package-actions-button/TripPackageAssignButton';
import { TripPackageRefuseButton } from '../../components/trip-package-actions-button/TripPackageRefuseButton';
import { DriverOptions } from '../../services/driver-options/driverOptionsContext';
import { t } from '../../services/translation/translation';
import { getFullName } from '../../utils/common';
import { formatDateForParisTZ } from '../../utils/date';
import { getTripPackageStatus, getTripPackageStatusVariant } from '../../utils/package';
import { formatPrice, formatPriceOptions } from '../../utils/price';

export const columns: TableColumn<DedicatedPackageOutput, DriverOptions>[] = [
  {
    name: t('common.id'),
    render: trippackage => {
      return (
        <div className="flex flex-col items-start">
          <div>
            <BadgeIndicator variant={getTripPackageStatusVariant(trippackage)}>
              {getTripPackageStatus(trippackage)}
            </BadgeIndicator>
            <span>{trippackage.id}</span>
          </div>
        </div>
      );
    },
  },
  {
    name: t('common.start-at'),
    render: trippackage => <p className="w-36">{formatDateForParisTZ(trippackage.startDate, t('date.datetime'))}</p>,
    sortKey: 'startDate',
  },
  {
    name: t('common.end-at'),
    render: trippackage => <p className="w-36">{formatDateForParisTZ(trippackage.endDate, t('date.datetime'))}</p>,
    sortKey: 'endDate',
  },
  {
    name: t('common.address'),
    render: trippackage => <p>{trippackage.referenceAddress.formattedAddress || '--'}</p>,
    sortKey: 'referenceAddress.formattedAddress',
  },
  {
    name: t('common.driver'),
    render: trippackage => (
      <div className={'text-red-600'}>
        {trippackage.driver ? (
          <Link to={`/drivers/${trippackage.driver.key}`}>
            {getFullName(trippackage.driver.firstName, trippackage.driver.lastName)}
          </Link>
        ) : (
          <div>{t('common.no-driver')}</div>
        )}
      </div>
    ),
    sortKey: 'packages.driver.lastName',
  },
  {
    name: t('common.price'),
    render: (trippackage, driverOptions) => (
      <p className="flex items-baseline lg:flex-col lg:gap-0 lg:items-start font-bold flex-row gap-1">
        {trippackage.totalPrice
          ? formatPrice(
              driverOptions.isSubjectToVAT ? trippackage.totalPrice?.amountWithTax : trippackage.totalPrice?.amount,
            )
          : null}{' '}
        <p className="text-[10px] opacity-50 font-normal">
          {trippackage.totalPrice ? formatPriceOptions(driverOptions) : null}
        </p>
        (
        {formatPrice(
          driverOptions.isSubjectToVAT ? trippackage.hourlyRate.amountWithTax : trippackage.hourlyRate.amount,
        )}
        /h)
      </p>
    ),
    sortKey: 'price',
  },
  {
    name: t('common.actions'),
    render: trippackage => (
      <div>
        {trippackage.status === 'PROPOSED' && trippackage.driver ? (
          <div className="space-y-3">
            <TripPackageAssignButton tripPackage={trippackage} driverKey={trippackage.driver?.key} />
            <TripPackageRefuseButton tripPackage={trippackage} driverKey={trippackage.driver?.key} />
          </div>
        ) : null}
      </div>
    ),
    sortKey: 'packages.driver.lastName',
  },
];
